import { Amplify } from 'aws-amplify';

export const amplifyConfig = {
  Auth: {
    Cognito: {
      //  Amazon Cognito User Pool ID
      userPoolId: import.meta.env.VITE_AWS_USER_POOL_ID,

      // Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolClientId: import.meta.env.VITE_AWS_USER_POOL_CLIENT_ID,

      // Optional: Sign-in domain prefix if you're using hosted UI
      signUpVerificationMethod: 'code', // 'code' | 'link'

      // AWS Region
      region: import.meta.env.VITE_AWS_REGION,
    },
  },
  // Optional: If you're using API Gateway + Lambda
  API: {
    GraphQL: {
      endpoint: import.meta.env.VITE_API_URL,
      region: import.meta.env.VITE_AWS_REGION,
      defaultAuthMode: 'userPool', // or 'iam' | 'apiKey' | 'oidc' | 'lambda'
    },
    REST: {
      api: {
        endpoint: import.meta.env.VITE_API_URL,
        region: import.meta.env.VITE_AWS_REGION,
        defaultAuthMode: 'userPool', // or 'iam' | 'apiKey' | 'oidc' | 'lambda'
      },
    },
  },
} as const;

// Initialize Amplify
Amplify.configure(amplifyConfig);
